import { render, staticRenderFns } from "./VendorFiles.vue?vue&type=template&id=57d3afdb"
import script from "./VendorFiles.vue?vue&type=script&lang=js"
export * from "./VendorFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports